export const objToParams = obj =>
  Object.keys(obj)
    .filter(k => obj[k])
    .map(k => `${k}=${obj[k]}`)
    .join('&');

export const UrlToObj = url =>
  url &&
  url
    .split('?')[1]
    .split('&')
    .reduce((acc, curr) => {
      const item = curr.split('=');
      acc[item[0]] = item[1];
      return acc;
    }, {});

export const blobToDataURL = blob =>
  new Promise(resolve => {
    const reader = new FileReader();
    reader.readAsDataURL(blob);
    reader.onload = () => {
      resolve(reader.result);
    };
  });
